import { FormControl, OutlinedInput, TextField } from "@mui/material";
import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";
import { TextL, TextM, TextMS, TextRS } from "../../common/text";

export const ContentContainer = styled(ContentContainerBase)`
  align-items: center;
`;

export const RegisterHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;

  padding-top: 30px;
  margin-bottom: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    padding-top: 5px;
    margin-bottom: 40px;
  }
`;

export const RegisterWrapper = styled.div`
  width: 60%;
  margin-bottom: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;
  gap: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 40px;
    margin-bottom: 70px;
  }
`;

export const PasswordInputWrapper = styled(FormControl)`
  width: "100%";
`;

export const PasswordInput = styled(OutlinedInput)`
  // 크롬 아이디 자동완성시 기본 배경색 제거
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
`;

export const PasswordConfirmInputWrapper = styled(FormControl)`
  width: "100%";
`;

export const PasswordConfirmInput = styled(OutlinedInput)`
  // 크롬 아이디 자동완성시 기본 배경색 제거
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
`;

export const LabelText = styled.span`
  font-size: 20px;
  font-family: "Bold";
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 28px;
  }
`;

export const NextButton = styled.div`
  width: 60%;
  height: 50px;
  background-color: ${({ isValidPassword }) =>
    isValidPassword ? "#f44b59" : "#eaeaea"};

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    height: 60px;
  }
`;

export const NextButtonText = styled(TextM)`
  color: ${({ isValidPassword }) => (isValidPassword ? "#FFF" : "#9F9F9F")};
`;
